import Switch from './Switch'
import HOC from './HOC'

import './style.css'

export default HOC(Switch)
